export const LOGIN_URL = "/systems/user/login"
export const EMPLOYEE_LEAVE_LIST = "/leaverequest/get-employee-leave-request-list"
export const EMPLOYEE_LEAVE_TYPE_LIST = "/leaverequest/get-employee-leave-type-list"
export const EMPLOYEE_LEAVE_REQUEST_CANCEL = "/leaverequest/apply-leave-canceled-by-user"
export const APPLY_LEAVE_EMPLOYEE = "/leaverequest/apply-leave"
export const APPLY_LEAVE_AUTO_APPROVED_EMPLOYEE = "/leaverequest/leave-auto-approve-apply-leave"
export const GET_APPLY_REQUEST_BY_ID = "/leaverequest/get-apply-leave-request"
export const GET_APPLY_REQUEST_BY_EMPLOYEEID = "/leaverequest/get-apply-leave-request-by-employeeid"
export const GET_ALL_LEAVE_REQUEST_LIST = "/leaverequest/get-leave-request-list"
export const LEAVE_REQUEST_UPDATE="/leaverequest/update-apply-leave"
export const LEAVE_APPROVE_APPLY_LEAVE="/leaverequest/approve-apply-leave"
export const EMPLOYEE_LEAVE_REPORT_LIST="/leaverequest/get-leave-request-report"
export const GET_REQUEST_LEAVE_COUNT="/leaverequest/get-leave-request-count"
export const GET_REQUEST_LEAVE_COUNT_WITH_SANDWICH_POLICY="/leaverequest/get-leave-request-count-with-sandwich-policy"
export const GET_EMP_LEAVE_TYPE_BALANCE="/leaverequest/get-employee-leave-type-balance"
export const GET_LEAVE_TYPE_LIST_BY_EMPLOYEE="/leaverequest/get-employee-leave-type-list-by-employee"
export const GET_ALL_EMPLOYEE_BALANCE="/leaverequest/get-employees-leave-balace-list"
export const LEAVE_APPROVE_CANCELED_BY_ADMIN="/leaverequest/approved-leave-cancelled-by-admin"
export const GET_LEAVE_LOP_ADJSUTMENT="/leaveadjustment/get-employee-leave-lop-adjustment-list"
export const ADD_EMPLOYEE_LEAVE_LOP_ADJUSTMENT="/leaveadjustment/add-employee-leave-lop-adjustment"
export const EXPORT_EMPLOYEE_LEAVE_LOP_ADJUSTMENT_DATA="/leaveadjustment/export-employee-leave-lop-adjustment-data"
export const GET_ALL_LEAVE_REQUEST_LIST_SUPERVISOR = "/leaverequest/get-employee-leave-request-list-supervisor"



// leave LeaveReconcilation
export const LEAVE_RECONCILATION_LIST = 'reconciliation/get-reconciliation-leaves'
export const APPLY_LEAVE_RECONCILATION_AUTO_APPROVED_BY_ADMINE = "/leaverequest/leave-reconcilation-auto-approve-apply-by-admin"
